import React from "react";
import { HiPlus, HiMinus } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";
import { addToCart, cejnToast, deleteFromCart } from "../../api/api";

// redux
import { setCart } from "../../redux/cartSlice";
import { useDispatch } from "react-redux";

export default function CartItem(props) {
    const [quantity, setQuantity] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch();

    React.useEffect(() => {
        let q = Number(props.row.quantity);
        setQuantity(!q || q < 1 ? 1 : q);
    }, [props.row.quantity]);

    const submitQuantity = (q) => {
        if (isNaN(q) || Number(q) < 1) {
            setQuantity(1);
            updateItem(1);
        } else {
            var nq = Number(q);
            if (nq === props.row.quantity) {
                return;
            }
            setQuantity(nq);
            updateItem(nq);
        }
    };

    const updateItem = async (q) => {
        if (q < 1) {
            return;
        }
        setLoading(true);

        let data = await addToCart(props.row.code, q);
        if (!data?.status.success) {
            cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.updateItem"), "ERROR");
            setLoading(false);
            return;
        }

        dispatch(setCart(data.items));

        // Only trigger update toast, if  we're on the cart page
        // and not in the minicart
        if (props.isCheckout) {
            cejnToast(data.status.message);
        }

        setLoading(false);
    };

    const deleteItem = async () => {
        setLoading(true);

        let data = await deleteFromCart(props.row.code);
        if (!data?.status.success) {
            cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.deleteItem"), "ERROR");
            setLoading(false);
        }

        dispatch(setCart(data.items));
        cejnToast(data.status.message);

        setLoading(false);
    };

    const handleEnterKey = (e) => {
        let isEnter = e.key === "Enter";
        if (isEnter) {
            submitQuantity(e.target.value);
        }
    };

    return (
        <tr className="c-cart__table-row">
            <td className="c-cart__table-item">
                <img src={props.row.imageUrl ? props.row.imageUrl + "?preset=c-article-list&width=68" : ""} />
            </td>

            <td className="c-cart__table-item">
                <a href={props.row.url}>{props.row.articleNumber}</a>
            </td>

            <td className="c-cart__table-item">{props.row.name}</td>

            <td className="c-cart__table-item">
                <div className="c-cart__utils">
                    <span className="c-cart__amount">
                        <HiMinus
                            onClick={() => updateItem(props.row.quantity - 1)}
                            style={{ cursor: props.row.quantity === 1 ? "not-allowed" : "pointer" }}
                        />

                        <input
                            disabled={loading}
                            type="text"
                            value={quantity || ""}
                            onChange={(e) => setQuantity(e.target.value)}
                            onBlur={(e) => submitQuantity(e.target.value)}
                            onKeyDown={(e) => handleEnterKey(e)}
                        />

                        <HiPlus onClick={() => updateItem(props.row.quantity + 1)} style={{ cursor: "pointer" }} />
                    </span>

          <FaTrash onClick={() => deleteItem()} style={{ cursor: "pointer" }} className="c-cart__trash-icon" />
        </div>
            </td>
        </tr>
    );
}
